@if (parsedParameters == null) {
  <div class="loader">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

@if (!isCloud && targetsNotDistinct && targetsToFilter !== null) {
  <div class="header">
    <mat-slide-toggle [(ngModel)]="showAllRows" (change)="maxRows = pageSize">
      <language key="TimelineShowAllParametersToggle" defaultValue="Show all parameters"></language>
    </mat-slide-toggle>
  </div>
}
@if (!isCloud) {
  <table mat-table [dataSource]="visibleOnPremParametersSlice()">
    <ng-container matColumnDef="attribute">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterAttribute" defaultValue="Attribute"></language>
      </th>
      <td mat-cell *matCellDef="let rp">{{ rp.PropertyDisplayName | async }}</td>
    </ng-container>
    <ng-container matColumnDef="operation">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterOperation" defaultValue="Operation"></language>
      </th>
      <td mat-cell *matCellDef="let rp">{{ rp.Mode }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterType" defaultValue="Type"></language>
      </th>
      <td mat-cell *matCellDef="let rp">
        @if (rp.ValueType) {
          {{ rp.ValueType }}
        } @else {
          <language key="TimelineUnknownType" defaultValue="⟨  Unknown ⟩"></language>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterValue" defaultValue="Value"></language>
      </th>
      <td mat-cell *matCellDef="let rp">
        @if (rp.Value | async) {
          @if (rp.ValueType === 'Guid') {
            <a (click)="openDetail.emit(rp.RawValue)" class="resource-link">{{
              rp.DisplayName | async
            }}</a>
          } @else if (rp.Download | async) {
            <a
              [href]="(rp.Download | async).objectUrl"
              [download]="(rp.Download | async).fileName"
              >{{ (rp.Download | async).linkText | async }}</a
            >
          } @else {
            {{ rp.Value | async }}
          }
        } @else {
          <language key="TimelineDeleted" defaultValue="⟨  Deleted ⟩"></language>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="target">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterTarget" defaultValue="Target"></language>
      </th>
      <td mat-cell *matCellDef="let rp">
        <a (click)="openDetail.emit(rp.Target)" class="resource-link">{{
          rp.TargetDisplayName | async
        }}</a>
      </td>
    </ng-container>
    @let premCols =
      targetsNotDistinct
        ? ['attribute', 'operation', 'type', 'value', 'target']
        : ['attribute', 'operation', 'type', 'value'];
    <tr mat-header-row *matHeaderRowDef="premCols"></tr>
    <tr mat-row *matRowDef="let row; columns: premCols"></tr>
  </table>
  @if (onPremHasMoreRows()) {
    <div class="footer">
      <button matButton="tonal" (click)="maxRows = maxRows + pageSize">
        <language key="TimelineShowMoreButtonText" defaultValue="Show more"></language>
      </button>
    </div>
  }
} @else {
  <table mat-table [dataSource]="parsedParameters | async">
    <ng-container matColumnDef="attribute">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterAttribute" defaultValue="Attribute"></language>
      </th>
      <td mat-cell *matCellDef="let change">{{ change.PropertyName }}</td>
    </ng-container>
    <ng-container matColumnDef="operation">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterOperation" defaultValue="Operation"></language>
      </th>
      <td mat-cell *matCellDef="let change">{{ change.Operation }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <language key="TimelineParameterType" defaultValue="Type"></language>
      </th>
      <td mat-cell *matCellDef="let change">{{ change.DataType }}</td>
    </ng-container>

    @if (showBeforeValue) {
      <ng-container matColumnDef="valueBefore">
        <th mat-header-cell *matHeaderCellDef>
          <language key="TimelineParameterValueBefore" defaultValue="Value before"></language>
        </th>
        <td mat-cell *matCellDef="let change">
          @if (change.Multivalued) {
            <mat-chip-set class="chip-preview-list">
              @if (change.DataType === 'Reference') {
                @for (v of change.Preview; track v) {
                  <mat-chip class="chip-clickable" (click)="onChipClick(v, $event)">{{
                    (v | async).dn
                  }}</mat-chip>
                }
              }
              @if (change.DataType !== 'Reference') {
                @for (v of change.Preview; track v) {
                  <mat-chip>{{ v }}</mat-chip>
                }
              }
              @if (change.RemainingValueCount > 0) {
                <mat-chip
                  class="chip-clickable chip-remaining"
                  (click)="onRemainingClick(change.Value, change.PropertyName, change.DataType)"
                  ><language
                    key="CtrlIdentitypickerMultiMoreItems"
                    defaultValue="… and {0} more."
                    [args]="[change.RemainingValueCount]"
                  ></language>
                </mat-chip>
              }
            </mat-chip-set>
          } @else {
            @if (change.DataType === 'Reference') {
              <a (click)="openDetail.emit(change.Value)">{{ change.DisplayName | async }}</a>
            } @else {
              {{ change.ValueBefore | async }}
            }
          }
        </td>
      </ng-container>
    }
    @if (showValue) {
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>
          <language key="TimelineParameterValue" defaultValue="Value"></language>
        </th>
        <td mat-cell *matCellDef="let change">
          @if (!change.Multivalued) {
            @if (change.DataType === 'Reference') {
              <a (click)="openDetail.emit(change.ValueBefore)">{{
                change.DisplayNameBefore | async
              }}</a>
            } @else {
              {{ change.Value | async }}
            }
          }
        </td>
      </ng-container>
    }

    @let cloudCols = ['attribute', 'operation', 'type'];
    @if (showBeforeValue) {
      @let x = cloudCols.push('valueBefore');
    }
    @if (showValue) {
      @let x = cloudCols.push('value');
    }
    <tr mat-header-row *matHeaderRowDef="cloudCols"></tr>
    <tr mat-row *matRowDef="let row; columns: cloudCols"></tr>
  </table>

  @if (noItems) {
    <p class="text-center"><language key="EmptyList" defaultValue="No items."></language></p>
  }
}
